<template>
    <el-card shadow="never"
             class="aui-card--fill">
        <div class="mod-sys__areaManager">
            <el-form label-position="top"
                     :inline="true"
                     :model="dataForm">
                <el-row>
                    <!-- 区域经理 -->
                    <el-col :span="6">
                        <el-form-item :label="$t('areaManager.name')">
                            <el-input v-model="dataForm.userName"
                                      clearable
                                      :placeholder="$t('assessment.userInput')"></el-input>
                        </el-form-item>
                    </el-col>
                    <!-- 所属经销商网点 -->
                    <el-col :span="6">
                        <el-form-item :label="$t('areaManager.orgAbbreviation')">
                            <el-select v-model="dataForm.orgId"
                                       remote
                                       clearable
                                       filterable
                                       reserve-keyword
                                       :placeholder="$t('user.input')"
                                       :remote-method="querySearch">
                                <el-option v-for="item in results"
                                           :key="item.orgId"
                                           :label="item.name"
                                           :value="item.orgId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <!-- 职位 -->
                    <el-col :span="6">
                        <el-form-item :label="$t('areaManager.jobName')">
                            <el-select v-model="dataForm.jobCode"
                                       clearable
                                       :placeholder="$t('user.select')">
                                <el-option v-for="(item,index) in positionArr"
                                           :key="index"
                                           :label="item.jobCode + '-' +item.positionName"
                                           :value="item.jobCode">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-col :span="24">
                            <el-button style="margin-bottom: 7px"
                                       class="M-search"
                                       type="primary"
                                       @click="query()">{{ $t('query') }}</el-button>
                        </el-col>
                        <el-col :span="24">
                            <el-button class="el-back M-search M-margin-l"
                                       type="info"
                                       @click="reset()">{{ $t('reset') }}</el-button>
                        </el-col>
                    </el-col>
                </el-row>
            </el-form>
            <el-form label-position="top"
                     :inline="true">
                <el-row>
                    <!-- 状态 -->
                    <el-col :span="6">
                        <el-form-item :label="$t('areaManager.status')">
                            <el-select v-model="dataForm.status"
                                       clearable
                                       :placeholder="$t('user.select')">
                                <el-option v-for="(item,index) in statusArr"
                                           :key="index"
                                           :label="item.name"
                                           :value="item.code">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div class="search">
                <!-- 新增按钮 -->
                <el-button type="primary"
                           @click="addUpdate()">{{ $t('add') }}</el-button>
            </div>
            <!-- 表格 -->
            <el-table :data="dataList"
                      v-loading="dataListLoading"
                      border
                      style="width: 100%">
                <!-- 区域经理ID -->
                <el-table-column prop="userCode"
                                 :label="$t('areaManager.userCode')"
                                 width="150"
                                 align="center"
                                 header-align="center"
                                 fixed
                                 :show-overflow-tooltip="true"></el-table-column>
                <!-- 员工号 -->
                <el-table-column prop="userCardNo"
                                 :label="$t('user.userCardNo')"
                                 width="150"
                                 align="center"
                                 header-align="center"
                                 fixed
                                 :show-overflow-tooltip="true"></el-table-column>
                <!-- 区域经理姓名 -->
                <el-table-column prop="userName"
                                 :label="$t('areaManager.userNameCn')"
                                 width="120"
                                 align="center"
                                 header-align="center"
                                 fixed
                                 :show-overflow-tooltip="true"></el-table-column>
                <!-- 部门 -->
                <el-table-column prop="dept"
                                 :label="$t('areaManager.deptCode')"
                                 width="120"
                                 align="center"
                                 header-align="center"
                                 :show-overflow-tooltip="true"></el-table-column>
                <!-- 组织编号 -->
                <el-table-column prop="orgCode"
                                 :label="$t('organization.orgCode')"
                                 width="110"
                                 align="center"
                                 header-align="center"></el-table-column>
                <!-- 品牌 -->
                <el-table-column prop="brand"
                                 :label="$t('organization.brandCodes')"
                                 width="100"
                                 align="center"
                                 header-align="center"></el-table-column>
                <!-- nscNo -->
                <el-table-column prop="nscNo"
                                 :label="$t('organization.nscNo')"
                                 width="130"
                                 align="center"
                                 header-align="center"></el-table-column>
                <!-- bbaNo -->
                <el-table-column prop="bbaNo"
                                 :label="$t('organization.bbaNo')"
                                 width="130"
                                 align="center"
                                 header-align="center"></el-table-column>
                <!-- 网点类型 -->
                <el-table-column prop="networkType"
                                 :label="$t('user.outletType')"
                                 width="100"
                                 align="center"
                                 header-align="center"></el-table-column>
                <!-- 区域 -->
                <el-table-column prop="area"
                                 :label="$t('organization.area')"
                                 width="100"
                                 align="center"
                                 header-align="center"></el-table-column>
                <!-- 网点名称 -->
                <el-table-column prop="orgName"
                                 :label="$t('areaManager.orgAbbreviation')"
                                 width="180"
                                 align="center"
                                 header-align="center"
                                 :show-overflow-tooltip="true"></el-table-column>

                <!-- 职位编号 -->
                <el-table-column prop="jobCode"
                                 :label="$t('position.positionCode')"
                                 width="110"
                                 align="center"
                                 header-align="center"></el-table-column>
                <!-- 职位名称 -->
                <el-table-column prop="positionName"
                                 :label="$t('position.positionNameCn')"
                                 width="130"
                                 align="center"
                                 header-align="center"
                                 :show-overflow-tooltip="true"></el-table-column>
                 <!-- 状态 -->
                <el-table-column prop="statusLabel"
                                 :label="$t('areaManager.status')"
                                 align="center"
                                 header-align="center"
                                ></el-table-column>
                <el-table-column align="center"
                                 width="130"
                                 :label="$t('handle')"
                                 fixed="right">
                    <template slot-scope="scope">
                        <el-dropdown trigger="click"
                                     placement="bottom">
                            <span class="el-dropdown-link">
                                {{ $t('handle') }}
                                <em class="el-icon-caret-bottom el-icon--right"></em>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <!-- 编辑 -->
                                <el-dropdown-item @click.native="addUpdate(scope.row)">{{ $t('areaManager.edit') }}</el-dropdown-item>
                                <!-- 不活动 -->
                                <el-dropdown-item v-if="scope.row.status ==='10'"
                                                  @click.native="changeStatus(scope.row.id,'20')">{{ $t('areaManager.inactive') }}</el-dropdown-item>
                                <!-- 活动 -->
                                <el-dropdown-item v-if="scope.row.status ==='20'"
                                                  @click.native="changeStatus(scope.row.id,'10')">{{ $t('areaManager.active') }}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination :current-page="page"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="limit"
                           :total="total"
                           layout="total, sizes, prev, pager, next, jumper"
                           @size-change="pageSizeChangeHandle"
                           @current-change="pageCurrentChangeHandle">
            </el-pagination>
            <!-- 弹窗, 新增 / 修改 -->
            <add-or-update v-if="addOrUpdateVisible"
                           ref="addOrUpdate"
                           @func="reload"></add-or-update>
        </div>
    </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import addOrUpdate from './areamanager-add-or-update'
import { moduleRoutes } from '@/router'
import Vue from 'vue'
export default {
    mixins: [mixinViewModule],
    data() {
        return {
            mixinViewModuleOptions: {
                getDataListURL: '/sys/commAreaManager/list',
                getDataListIsPage: true,
            },
            dataList: [],
            dataListLoading: false,
            dataForm: {},
            positionArr: [],
            results: [],
            statusArr: this.enums['status'],
        }
    },
    components: {
        addOrUpdate
    },
    created() {
        this.$request.get('/sys/commAreaManager/areaPosition')
            .then((res, total, code, data) => {
                this.positionArr = res
                this.positionArr = JSON.parse(JSON.stringify(this.positionArr))
            }).catch((err) => {
                console.log(err)
            })
    },
    methods: {
        reload(data) {
            if (data === true) {
                this.query()
            }
        },
        addUpdate(row) {
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                if (row === undefined) {
                    this.$refs.addOrUpdate.dataForm.id = ''
                    this.$refs.addOrUpdate.dataForm.userId = ''
                    this.$refs.addOrUpdate.dataForm.jobCode = ''
                    this.$refs.addOrUpdate.dataForm.orgId = ''
                    this.$refs.addOrUpdate.canEdit = false
                } else {
                    this.$refs.addOrUpdate.dataForm.id = row.id
                    this.$refs.addOrUpdate.dataForm.orgId = row.brand + '_' + row.networkType + '_' + row.bbaNo + '_' + row.nscNo + '_' + row.orgName
                    this.$refs.addOrUpdate.dataForm.jobCode = row.jobCode + '_' + row.positionName
                    this.$refs.addOrUpdate.dataForm.userId = row.userCode + '_' + row.userName + '_' + row.userCardNo
                    this.$refs.addOrUpdate.canEdit = true
                }
                this.$refs.addOrUpdate.init()
            })
        },
        // 获取公司信息
        querySearch(queryString) {
            this.$request.get('/sys/org/queryOutletList',
                {
                    name: queryString,
                }
            ).then((res, total, code, data) => {
                this.results = res
                this.results = this.results.map(item => {
                    item['value'] = item.name
                    return item
                })
            }).catch((err) => {
                console.log(err)
            })
        },
        changeStatus(id, status) {
            this.$request.post(
                '/sys/commAreaManager/update',
                {
                    id: id,
                    status: status,
                }
            ).then((res, tota, code, data) => {
                this.$message({
                    message: this.$t('prompt.success'),
                    type: 'success',
                    duration: 500
                })
                this.query()
            }).catch((err) => {
                console.log(err)
            })
        }

    }
}
</script>
